import { useQuery } from '@tanstack/react-query';
import { financialReportKeys } from '@/lib/query-keys';
import { financialService } from '@/services/financial.service';

export function useFinancialReports(params: Record<string, unknown> = {}) {
  const pnlQuery = useQuery({
    queryKey: financialReportKeys.pnl(params),
    queryFn: () => financialService.getPnlReport(params),
    enabled: !!params.dateFrom,
  });

  const cashFlowQuery = useQuery({
    queryKey: financialReportKeys.cashFlow(params),
    queryFn: () => financialService.getCashFlowReport(params),
    enabled: !!params.dateFrom,
  });

  const expenseSummaryQuery = useQuery({
    queryKey: financialReportKeys.expenseSummary(params),
    queryFn: () => financialService.getExpenseSummary(params),
    enabled: !!params.dateFrom,
  });

  const revenueForecastQuery = useQuery({
    queryKey: financialReportKeys.revenueForecast(params),
    queryFn: () => financialService.getRevenueForecast(params),
  });

  const agingQuery = useQuery({
    queryKey: financialReportKeys.aging(params),
    queryFn: () => financialService.getAgingReport(params),
  });

  return {
    pnl: pnlQuery.data?.data,
    pnlLoading: pnlQuery.isLoading,
    cashFlow: cashFlowQuery.data?.data,
    cashFlowLoading: cashFlowQuery.isLoading,
    expenseSummary: expenseSummaryQuery.data?.data,
    expenseSummaryLoading: expenseSummaryQuery.isLoading,
    revenueForecast: revenueForecastQuery.data?.data,
    revenueForecastLoading: revenueForecastQuery.isLoading,
    aging: agingQuery.data?.data,
    agingLoading: agingQuery.isLoading,
  };
}
